import { DocumentNode, gql } from '@apollo/client'

export const CREATE_GROUP: DocumentNode = gql`
    mutation CreateGroup($daycare_id: Int!, $name: String!) {
        createGroup(daycare_id: $daycare_id, name: $name)
    }
`

export const GET_GROUPS: DocumentNode = gql`
    query GetGroups($daycare_id: Int!) {
        getGroups(daycare_id: $daycare_id) {
            id
            daycareId
            name
        }
    }
`

export const UPDATE_GROUP: DocumentNode = gql`
    mutation UpdateGroup($group_id: Int!, $name: String, $daycare_id: Int!) {
        updateGroup(group_id: $group_id, name: $name, daycare_id: $daycare_id)
    }
`

export const DELETE_GROUP: DocumentNode = gql`
    mutation DeleteGroup($group_id: Int!, $daycare_id: Int!) {
        deleteGroup(group_id: $group_id, daycare_id: $daycare_id)
    }
`
